module.exports = __webpack_public_path__ + "images/category_lp/brand/assessment_achievements/6_10f7730de543cb040404a74bf9967122.jpg";